import './App.css'
import React, { ReactElement } from 'react'
import { BrowserRouter as Router, Switch, Route } from "react-router-dom"
import { Layout } from 'antd'

import TopMenu from './component/TopMenu'
import SideMenu from './component/SideMenu'
import UserData from './js/userData'
import Icon1 from './images/icon.png'

// 页面路径引用
// 首页
import HeaderUserMenu from './component/HeaderUserMenu'
import Index from './pages/index/Index'

// 会员中心
import MemberList from './pages/memberCentre/MemberList'
import MemberDetail from './pages/memberCentre/MemberDetail'

// 商城中心
import ProductList from './pages/mallCentre/ProductList'
import AddEditProduct from './pages/mallCentre/AddEditProduct'
import ProductSpecsList from './pages/mallCentre/ProductSpecsList'
import AddEditProductSpecs from './pages/mallCentre/AddEditProductSpecs'
import ProductPutList from './pages/mallCentre/ProductPutList'
import AddEditProductPut from './pages/mallCentre/AddEditProductPut'
import ProductOrderList from './pages/mallCentre/ProductOrderList'

import ConfigProductTypeList from './pages/mallCentre/ConfigProductTypeList'
import ConfigSpecsList from './pages/mallCentre/ConfigSpecsList'
import SupplierList from './pages/mallCentre/SupplierList'
import AddEditSupplier from './pages/mallCentre/AddEditSupplier'

function NoMatch() {
  return <div className="common-page">404...没有相关页面...</div>
}

const { Header, Content } = Layout

type AppState = {
  topIndex: string,
  topNavData: any[],
  sideSelectedKeys: string,
  sideOpenKeys: string,

  sideMenuData: {
    belongIndex: number,
    key: string,
    title: string,
    icon: ReactElement,
    items: {
      key: string,
      title: string,
      url?: string
    }[]
  }[]
}

class App extends React.Component {

  state: AppState = {
    topIndex: '',
    sideOpenKeys: '',
    sideSelectedKeys: '',
    topNavData: [],
    sideMenuData: []
  }

  handleTopNavClick({ key }: { key: string }) {
    for (let i = 0; i < this.state.sideMenuData.length; i++) {
      let o: any = this.state.sideMenuData[i]

      if (o.p_id === this.state.topNavData[Number(key)].id) {
        this.syncMenuKey(o.children[0].route_url)
        break
      }
    }

    this.setState({ topIndex: key })
  }

  handleSideMenuClick({ key }: { key: string }) {
    this.setState({ sideSelectedKeys: key })
  }

  handleSideSubMenuClick({ key }: { key: string }) {
    this.state.sideOpenKeys === key ? this.setState({ sideOpenKeys: '' }) : this.setState({ sideOpenKeys: key })
  }

  syncMenuKey(url: string) {
    let current: { key: string, childKey: string } = { key: '', childKey: '' }

    this.state.sideMenuData.forEach((el: any) => {
      el.children.forEach((el2: any) => {
        if (el2.route_url === url) {
          current.key = el2.p_id
          current.childKey = el2.id
        }
      })
    })

    window.localStorage.setItem('url_id', current.childKey)

    this.setState({
      sideOpenKeys: current.key,
      sideSelectedKeys: current.childKey
    })
  }

  setSideHeight() {
    let aside = document.querySelectorAll('aside')[0] as HTMLElement
    let header = document.querySelectorAll('header')[0] as HTMLElement
    let info = document.querySelectorAll('.info')[0] as HTMLElement

    aside.style.minHeight = window.innerHeight - header.offsetHeight - info.offsetHeight + 'px'
  }

  // 修复顶层菜单对应左边导航第一个页面的权限问题
  fixTopLevelAuth(topArr: any[]): any[] {
    let newTopMenuArr: any[] = []

    function getFirstPageRouteUrl(pid: string): string {
      let url = ''

      if (UserData.left_menu_list.find((el: any) => el.p_id === pid) && UserData.left_menu_list.find((el: any) => el.p_id === pid)['children'] && UserData.left_menu_list.find((el: any) => el.p_id === pid)['children'][0] && UserData.left_menu_list.find((el: any) => el.p_id === pid)['children'][0].route_url) {
        url = UserData.left_menu_list.find((el: any) => el.p_id === pid)['children'][0].route_url
      }

      return url || ''
    }

    topArr.forEach(el => {
      el.route_url = getFirstPageRouteUrl(el.id)
      newTopMenuArr.push(el)
    })

    return newTopMenuArr
  }

  setMenuData() {
    let pathName = window.location.pathname,
      tIndex = ''

    UserData.left_menu_list.forEach((el: any, index: number) => {
      el.children.forEach((el2: any) => {
        if (el2.route_url === pathName) {

          UserData.top_menu_list.forEach((el3: any, index3: number) => {
            if (el3.id === el.p_id) tIndex = index3.toString()
          })
        }
      })
    })

    this.setState({
      topIndex: tIndex.toString(),
      topNavData: this.fixTopLevelAuth(UserData.top_menu_list),
      sideMenuData: UserData.left_menu_list

    }, () => {
      this.syncMenuKey(pathName)
    })
  }

  init() {
    this.setSideHeight()
    this.setMenuData()

    window.addEventListener('resize', (e) => {
      this.setSideHeight()
    })
  }

  componentDidMount() {
    this.init()
  }

  render(): ReactElement {

    return (
      <div className="app">
        <Router>
          <Layout>
            <div className="info clear" id="info">
              <div className="logo clear fl" >
                <h1><img src={Icon1} alt="logo" />兴宝月禧商城中台</h1>
              </div>

              <div className="fr">
                <HeaderUserMenu />
              </div>
            </div>

            <Header className="header">
              <div className="shadow"></div>

              <TopMenu
                topIndex={this.state.topIndex}
                topNavData={this.state.topNavData}
                handleTopNavClick={({ key }: { key: string }) => {
                  this.handleTopNavClick({ key })
                }}
              />
            </Header>

            <Layout>
              <SideMenu
                handleSideSubMenuClick={({ key }: { key: string }) => { this.handleSideSubMenuClick({ key }) }}
                handleSideMenuClick={({ key }: { key: string }) => { this.handleSideMenuClick({ key }) }}
                topIndex={this.state.topIndex}
                sideMenuData={this.state.sideMenuData}
                topMenuData={this.state.topNavData}
                sideOpenKeys={this.state.sideOpenKeys}
                sideSelectedKeys={this.state.sideSelectedKeys} />

              <Layout style={{ padding: '0 24px 24px' }}>
                <Content className="site-layout-background" style={{ padding: 24, margin: 0, minHeight: 280 }}>
                  <Switch>

                    {/* ******************** 首页 start ******************** */}

                    {/* 首页 */}
                    <Route path="/" exact>
                      <Index />
                    </Route>

                    {/* ******************** 首页 end ******************** */}

                    {/* ******************** 会员中心 start ******************** */}

                    {/* 会员管理 */}
                    <Route path="/member_list">
                      <MemberList />
                    </Route>
                    <Route path="/member_detail/:id">
                      <MemberDetail />
                    </Route>

                    {/* ******************** 会员中心 end ******************** */}

                    {/* ******************** 商城中心 start ******************** */}

                    {/* 商品管理 */}
                    <Route path="/product_list">
                      <ProductList />
                    </Route>
                    <Route path="/product_add">
                      <AddEditProduct />
                    </Route>
                    <Route path="/product_edit/:id">
                      <AddEditProduct />
                    </Route>

                    <Route path="/product_specs_list">
                      <ProductSpecsList />
                    </Route>
                    <Route path="/product_specs_add">
                      <AddEditProductSpecs />
                    </Route>
                    <Route path="/product_specs_edit/:id">
                      <AddEditProductSpecs />
                    </Route>

                    <Route path="/product_put_list">
                      <ProductPutList />
                    </Route>
                    <Route path="/product_put_add">
                      <AddEditProductPut />
                    </Route>
                    <Route path="/product_put_edit/:id">
                      <AddEditProductPut />
                    </Route>

                    <Route path="/product_order_list">
                      <ProductOrderList />
                    </Route>

                    {/* 配置管理 */}
                    <Route path="/product_type_List">
                      <ConfigProductTypeList />
                    </Route>

                    <Route path="/specs_list">
                      <ConfigSpecsList />
                    </Route>

                    <Route path="/supplier_list">
                      <SupplierList />
                    </Route>
                    <Route path="/supplier_add">
                      <AddEditSupplier />
                    </Route>
                    <Route path="/supplier_edit/:id">
                      <AddEditSupplier />
                    </Route>

                    {/* ******************** 商城中心 end ******************** */}

                    <Route path="*">
                      <NoMatch />
                    </Route>

                  </Switch>
                </Content>
              </Layout>
            </Layout>
          </Layout>
        </Router>
      </div>
    )
  }
}

export default App